import AxiosInstanceCreator from 'services/api';
import type { IAlarm, ReqAlarms, ResAlarms } from '../models/alarm.model';
import type { BaseApiResponse, ResultBaseProps } from 'modules/common';
import type { AxiosInstance } from 'axios';
import { ReqCreateEnvAlarm } from '../models/create.model';
import { ResUnreadAlarmCount } from '../models/unread.model';

const alarmInstance = new AxiosInstanceCreator().create();

export const alarmApi = {
  /**
   * environment 웹 푸쉬 발생 api
   */
  async createEnvAlarm(data: ReqCreateEnvAlarm): Promise<ResultBaseProps> {
    return alarmInstance.post(`/alarm/environment`, data).then((res) => res.data);
  },

  /**
   * 알람 리스트 조회
   * @param {userId, status, keyword} data
   */
  async fetchAlarms(query: string): Promise<ResAlarms> {
    return alarmInstance.get(`/alarm/${query}`).then((res) => res.data);
  },

  /**
   * 읽지 않은 알람 카운트
   * @param {userId} id
   * @returns
   */
  async fetchUnreadAlarmCount(): Promise<ResUnreadAlarmCount> {
    return alarmInstance.get(`/alarm/unread`).then((res) => res.data);
  },

  /**
   * 알람 읽음 처리
   * @param {mappingId} id
   * @returns
   */
  async createAlarmReaded(id: string): Promise<ResultBaseProps> {
    return alarmInstance.post(`/alarm/${id}`).then((res) => res.data);
  }
};

export class AlarmAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  /** environment 웹 푸쉬 발생 API */
  async createEnvAlarm(data: ReqCreateEnvAlarm): Promise<BaseApiResponse> {
    return this.Axios.post<BaseApiResponse>(`/alarm/environment`, data).then((res) => res.data);
  }

  /** 알람 리스트 조회 API */
  async fetchAlarms(request: ReqAlarms): Promise<BaseApiResponse<unknown, IAlarm>> {
    return this.Axios.get<BaseApiResponse<unknown, IAlarm>>(`/alarm`, { params: request }).then(
      (res) => res.data
    );
  }

  /** 읽지 않은 알람 카운트 API */
  async fetchUnreadAlarmCount(): Promise<BaseApiResponse<number>> {
    return this.Axios.get<BaseApiResponse<number>>(`/alarm/unread`).then((res) => res.data);
  }

  /** 알람 읽음 처리 API */
  async createAlarmReaded(id: string): Promise<BaseApiResponse> {
    return this.Axios.post<BaseApiResponse>(`/alarm/read/${id}`).then((res) => res.data);
  }
}
